import { render, staticRenderFns } from "./CalendarSettings.vue?vue&type=template&id=662384c1&scoped=true&"
import script from "./CalendarSettings.vue?vue&type=script&lang=js&"
export * from "./CalendarSettings.vue?vue&type=script&lang=js&"
import style0 from "./CalendarSettings.vue?vue&type=style&index=0&id=662384c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662384c1",
  null
  
)

export default component.exports